const FETCH = "FETCH";

export { FETCH };